var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.computedLabel},[_vm._v(_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"value":_vm.internalValue},on:{"change":_vm.emitvalue}}),_c('span',{class:_vm.computedCheckmark})])
}
var staticRenderFns = []

export { render, staticRenderFns }